const OIDC_REDIRECT_KEY = 'oidcPostLoginRedirect'

export const saveOidcPostLoginRedirect = (redirectTo) => {
    if (redirectTo?.startsWith('/') && !redirectTo.startsWith('//')) {
        sessionStorage.setItem(OIDC_REDIRECT_KEY, redirectTo)
        return
    }

    sessionStorage.removeItem(OIDC_REDIRECT_KEY)
}

export const takeOidcPostLoginRedirect = () => {
    const redirectTo = sessionStorage.getItem(OIDC_REDIRECT_KEY)
    sessionStorage.removeItem(OIDC_REDIRECT_KEY)
    return redirectTo
}
